export const locale = {
  connect_device: 'Connect Your Device',
};
